import { Overlay } from '@models';

export type Rendering = {
  id: string;
  overlay: Overlay;
  timeout?: number;
  timeStamp?: number;
  replace?: { id: string; persist?: boolean };
};
